// © 2015-2021 WDNA - All Rights Reserved

import * as React from 'react';

type ButtonAttributes = {
  label: string;
  action: (e: React.MouseEvent<HTMLButtonElement>) => void;
}

interface Props {
  loading?: boolean;
  disabled?: boolean;
  buttons?: ButtonAttributes[];
  onReset: (e: React.MouseEvent<HTMLButtonElement>) => void;
}

/**
 * Function to create a React Component component
 *
 * @param props component properties
 * @returns react node component
 */
export default function ButtonsForm(props: Props): JSX.Element {
  const { loading, disabled, buttons, onReset } = props;

  const style: React.CSSProperties = { marginRight: '10px' };

  return (
    <fieldset>
      <footer>
        <div className="text-right">
          {loading && (
            <img className="loading-wdna" alt="loading" src="assets/img/loading-wdna.gif" />
          )}
          {buttons?.map((item: ButtonAttributes) => {
            return (
              <button style={style} type="button" className="btn btn-primary" disabled={disabled} onClick={item.action}>
                {item.label}
              </button>
            );
          })}
          <button style={style} type="submit" className="btn btn-primary" disabled={disabled}>
            Save
          </button>
          <button style={style} type="button" className="btn btn-primary" disabled={disabled} onClick={onReset}>
            Reset
          </button>
        </div>
      </footer>
    </fieldset>
  );
}

ButtonsForm.defaultProps = {
  loading: false,
  disabled: false,
  buttons: []
};
